module.exports = __webpack_public_path__ + "static/media/crutch.3c9b6de9.svg";